(function(){
  const API_BASE = 'https://app.bepivotal.co.uk/api/v1';

  // Performance optimizations
  let currentAbortController = null;
  let debounceTimer = null;
  let ssrFallbackTimer = null;
  const SSR_FALLBACK_TIMEOUT = 3500; // ms before showing SSR fallback
  function showSsrFallback(){
    const ssrGrid = $('[data-ssr-grid]');
    const clientGrid = $('[data-client-grid]');
    if(clientGrid){
      clientGrid.style.display = 'none';
    }
    if(ssrGrid){
      ssrGrid.style.display = 'grid';
    }
  }

  const DEBOUNCE_DELAY = 300; // ms
  const CACHE_DURATION = 60000; // 1 minute cache
  const responseCache = new Map();

  // Track filter/sort state to detect pagination-only changes (skip requesting filters/sorts on page nav)
  let lastFilterStateKey = null;

  // Track whether CSR has rendered products — used to know if SSR should be restored on loading cancel
  let csrProductsRendered = false;

  function getFilterStateKey(state) {
    return JSON.stringify({
      sort: state.sort,
      filters: state.filters,
      q: state.q,
      price_min: state.price_min,
      price_max: state.price_max
    });
  }

  function qsAll(sel, root=document){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function $(sel, root=document){ return root.querySelector(sel); }

  function parseQuery(qs){
    const params = new URLSearchParams(qs.startsWith('?') ? qs : '?' + qs);
    const out = {};
    params.forEach((v,k)=>{
      if(k.endsWith('[]')){
        const key = k.slice(0,-2);
        if(!out[key]) out[key]=[];
        out[key].push(v);
      }else{
        out[k]=v;
      }
    });
    return out;
  }

  // Map URL filter keys to API filter keys
  // The /listings API uses simple keys: room, colour, thickness, etc.
  function mapFilterKeyToApiKey(urlKey, availableFilters) {
    const normalizedUrlKey = urlKey.toLowerCase().trim();

    // Normalize legacy "suitability" to "room" (the API's expected key)
    if (normalizedUrlKey === 'suitability') return 'room';

    // If available filters are loaded, try to match against them
    if (availableFilters && Array.isArray(availableFilters) && availableFilters.length > 0) {
      for (const filter of availableFilters) {
        const filterKey = (filter.key || '').toLowerCase().trim();
        if (filterKey === normalizedUrlKey) {
          return filter.key || urlKey;
        }
      }
    }

    return urlKey;
  }

  function buildQuery(state, forApi){
    const p = new URLSearchParams();
    if(state.page) p.set('page', state.page);
    if(state.per_page) p.set('per_page', state.per_page);
    if(state.sort) {
      // API uses `sort`, Shopify URL uses `sort_by`
      if(forApi){
        p.set('sort', state.sort);
      } else {
        p.set('sort_by', state.sort);
      }
    }
    if(state.q) p.set('q', state.q);
    if(state.price_min != null && state.price_min !== '' && state.price_min !== 'null') p.set('price_min', state.price_min);
    if(state.price_max != null && state.price_max !== '' && state.price_max !== 'null') p.set('price_max', state.price_max);
    if(state.filters){
      // Get available filters from window if available (set by category-filters-api.js)
      const availableFilters = (window.categoryFiltersData && window.categoryFiltersData.filters) || [];
      
      Object.keys(state.filters).forEach(key=>{
        const values = Array.isArray(state.filters[key]) ? state.filters[key] : [state.filters[key]];
        // Map the URL filter key to the API filter key format
        const apiKey = forApi ? mapFilterKeyToApiKey(key, availableFilters) : key;
        
        // Always use filters[key][] format for multiple values
        values.forEach(val=> {
          // Ensure value is properly encoded
          const encodedVal = String(val).trim();
          p.append(`filters[${apiKey}][]`, encodedVal);
        });
      });
    }
    return p.toString();
  }

  function isSearchPage(){
    return window.location.pathname === '/search' || window.location.pathname.startsWith('/search/');
  }

  function getCollectionHandle(){
    // Prefer data attribute set on section
    const sec = $('.category-products-grid[data-collection-handle]') || document.body;
    const handle = sec && sec.getAttribute && sec.getAttribute('data-collection-handle');
    if(handle) return handle;
    // Fallback from URL: /collections/{handle}
    const parts = window.location.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('collections');
    if(idx>=0 && parts[idx+1]) return parts[idx+1];
    return '';
  }

  function stateFromUrl(){
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const state = {
      page: params.get('page') || 1,
      per_page: params.get('per_page') || 22,
      sort: params.get('sort') || params.get('sort_by') || null,
      q: params.get('q') || null,
      price_min: params.get('price_min') || params.get('filter.v.price.gte'),
      price_max: params.get('price_max') || params.get('filter.v.price.lte'),
      filters: {}
    };
    
    // Collect filters in multiple formats:
    // 1. Our format: filters[foo]=bar (no trailing [])
    // 2. Legacy format: filters[foo][]=bar
    // 3. Shopify format: filter.p.product_type=Living+Room, filter.v.option.colour=Grey
    params.forEach((v,k)=>{
      // Our format: filters[foo]=bar or filters[foo][]=bar or filters[foo][][]=bar
      // Match any number of trailing [] brackets
      const filterMatch = k.match(/^filters\[([^\]]+)\](\[\])*$/);
      if(filterMatch){
        let key = filterMatch[1].toLowerCase();
        // Normalize "suitability" to "room" for consistency (room is more user-friendly)
        if (key === 'suitability') {
          key = 'room';
        }
        if(!state.filters[key]) state.filters[key] = [];
        state.filters[key].push(v);
      }
      // Shopify format: filter.p.product_type, filter.v.option.colour, filter.p.m.custom.thickness, etc.
      else if(k.startsWith('filter.')){
        // Skip price filters (already handled above)
        if(k.includes('.price.')) return;
        
        // Extract the filter name from the key
        let filterName = k;
        
        // Map common Shopify filter patterns to simple names
        if(k.includes('.product_type')) filterName = 'product_type';
        else if(k.includes('.vendor')) filterName = 'brand';
        else if(k.includes('.option.colour') || k.includes('.option.color')) filterName = 'colour';
        else if(k.includes('.m.custom.')) {
          // Extract metafield name: filter.p.m.custom.thickness -> thickness
          const metaMatch = k.match(/\.m\.custom\.(.+)$/);
          if(metaMatch) filterName = metaMatch[1];
        }
        else if(k.includes('.option.')) {
          // Extract option name: filter.v.option.size -> size
          const optMatch = k.match(/\.option\.(.+)$/);
          if(optMatch) filterName = optMatch[1];
        }
        else {
          // Generic: extract last part after last dot
          const parts = k.split('.');
          filterName = parts[parts.length - 1];
        }
        
        // Normalize filter name to lowercase and handle "suitability" -> "room"
        if (filterName) {
          filterName = filterName.toLowerCase();
          if (filterName === 'suitability') {
            filterName = 'room';
          }
        }
        
        // Add to filters
        if(!state.filters[filterName]) state.filters[filterName] = [];
        state.filters[filterName].push(v);
      }
    });
    return state;
  }

  function updateUrl(state){
    const q = buildQuery(state, false);
    const url = new URL(window.location.href);
    url.search = q;
    window.history.replaceState({}, '', url.toString());
  }

  // Render star rating from API data
  function renderRating(ratings){
    if(!ratings || !ratings.average || ratings.count === 0){
      return '';
    }
    
    const average = parseFloat(ratings.average);
    const count = parseInt(ratings.count);
    const fullStars = Math.floor(average);
    const hasHalfStar = (average % 1) >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    
    // Star SVG (filled) - Orange color to match SSR Yotpo stars
    const starFilled = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#FF9800"><path d="M8 0l2.163 4.382 4.837.703-3.5 3.412.826 4.818L8 11.236l-4.326 2.079.826-4.818-3.5-3.412 4.837-.703L8 0z"/></svg>`;
    
    // Star SVG (half) - Orange color to match SSR Yotpo stars
    const starHalf = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><defs><linearGradient id="half-${average}"><stop offset="50%" stop-color="#FF9800"/><stop offset="50%" stop-color="#E8E8E8"/></linearGradient></defs><path fill="url(#half-${average})" d="M8 0l2.163 4.382 4.837.703-3.5 3.412.826 4.818L8 11.236l-4.326 2.079.826-4.818-3.5-3.412 4.837-.703L8 0z"/></svg>`;
    
    // Star SVG (empty) - Light gray to match SSR Yotpo stars
    const starEmpty = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="#E8E8E8"><path d="M8 0l2.163 4.382 4.837.703-3.5 3.412.826 4.818L8 11.236l-4.326 2.079.826-4.818-3.5-3.412 4.837-.703L8 0z"/></svg>`;
    
    let starsHtml = '';
    for(let i = 0; i < fullStars; i++) starsHtml += starFilled;
    if(hasHalfStar) starsHtml += starHalf;
    for(let i = 0; i < emptyStars; i++) starsHtml += starEmpty;
    
    return `
      <div class="product-rating-stars" style="display: flex; align-items: center; gap: 6px;">
        <div class="stars" style="display: flex; gap: 3px;">${starsHtml}</div>
        <span class="rating-text" style="font-size: 13px; color: #3D4E5F; font-weight: 600;">${average.toFixed(1)}</span>
        <span class="rating-count" style="font-size: 13px; color: #6E6E73;">(${count})</span>
      </div>
    `;
  }

  function setLoading(loading){
    const clientGrid = $('[data-client-grid]');
    const ssrGrid = $('[data-ssr-grid]');
    
    if(loading){
      csrProductsRendered = false;
      // Hide SSR immediately and show loading state on CSR
      if(ssrGrid){
        ssrGrid.style.display = 'none';
      }
      if(clientGrid){
        clientGrid.style.display = 'grid';
        clientGrid.style.opacity = '1';
        clientGrid.innerHTML = `
          <div style="grid-column: 1 / -1; text-align: center; padding: 80px 20px;">
            <div style="display: inline-block; width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top-color: #3D4E5F; border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
            <p style="margin-top: 20px; color: #3D4E5F; font-size: 16px; font-weight: 500;">Loading products...</p>
            <style>
              @keyframes spin {
                to { transform: rotate(360deg); }
              }
            </style>
          </div>
        `;
      }
    } else {
      if(!csrProductsRendered){
        // renderGrid was never called (request aborted/failed) — restore SSR
        if(clientGrid){
          clientGrid.style.display = 'none';
          clientGrid.innerHTML = '';
        }
        if(ssrGrid){
          ssrGrid.style.display = 'grid';
        }
      } else {
        if(clientGrid) clientGrid.style.opacity = '1';
      }
    }
  }

  function formatMoneyMinor(minor, currency){
    if(minor == null) return '';
    const value = Number(minor)/100;
    return new Intl.NumberFormat(undefined, { style:'currency', currency: currency || 'GBP' }).format(value);
  }

  function renderProductCard(p){
    if(!p || !p.id || !p.title) return ''; // Skip invalid products

    // Fix variant URL: convert GID format to numeric so Shopify selects the correct variant
    let productUrl = p.url || '';
    productUrl = productUrl.replace(/variant=gid:\/\/shopify\/ProductVariant\/(\d+)/, 'variant=$1');

    // Clean display title: strip size suffix like "/ 4m" from variant titles
    const displayTitle = (p.title || '').replace(/\s*\/\s*\d+m\s*$/, '');

    const hasMultiple = (p.images && p.images.length>1);
    const firstImg = p.images && p.images[0];
    const imgStack = (p.images||[]).map((img,idx)=>{
      const active = idx===0 ? ' active' : '';
      const hide = idx===0 ? '' : ' style="display:none;"';
      return `<img src="${img.src}" alt="${(img.alt||p.title).replace(/"/g,'&quot;')}" class="product-main-image${active}" width="${img.width||398}" height="${img.height||398}"${hide}>`;
    }).join('');

    // Secondary badges - render full HTML structure like Liquid snippets
    const tags = p.tags || [];
    const hasWaterproofTag = tags.some(tag => String(tag).toLowerCase().includes('waterproofbadge'));
    const hasHerringboneTag = tags.some(tag => String(tag).toLowerCase().includes('herringbonebadge'));
    const waterproof = p.badges && p.badges.waterproof || hasWaterproofTag;
    const herringbone = p.badges && p.badges.herringbone || hasHerringboneTag;
    
    let secondaryBadge = '';
    if(waterproof){
      secondaryBadge = `<div class="water-badge-container water-badge-water-resistant" style="position: absolute; bottom: 60px; right: 16px; z-index: 15; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; width: 80px; height: 80px; border-radius: 50%; border: 1px solid #ffffff; background-color: #ACD0D1; color: #3D4E5F;">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="39.625" height="42.705" viewBox="0 0 39.625 42.705" style="width: 33px; height: 35px;">
          <g transform="translate(3 3)">
            <path d="M34.211,33.905a6.337,6.337,0,0,0-10.9,0,6.337,6.337,0,0,0-10.9,0,6.337,6.337,0,0,0-10.9,0,16.468,16.468,0,0,1,32.711,0Z" transform="translate(-1.043 -13.458)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line y1="0.979" transform="translate(16.813 4.92)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M42.656,56.9V73.066a2.742,2.742,0,0,1-5.485,0V71.3" transform="translate(-25.843 -39.56)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M10.107,5.037c0-1.052,1.9-3.537,1.9-3.537s1.9,2.485,1.9,3.537a1.9,1.9,0,1,1-3.809,0Z" transform="translate(-7.027 -1.043)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M91.95,15.345c0-1.052,1.9-3.537,1.9-3.537s1.9,2.485,1.9,3.537a1.9,1.9,0,1,1-3.809,0Z" transform="translate(-63.928 -8.209)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M39.92,31.806c0-1.052,1.9-3.537,1.9-3.537s1.9,2.485,1.9,3.537a1.9,1.9,0,1,1-3.809,0Z" transform="translate(-27.754 -19.654)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </g>
        </svg>
        <div class="water-badge-content" style="display: flex; flex-direction: column; gap: 0px; text-align: center; align-items: center; justify-content: center;">
          <div class="water-badge-title text-dark" style="font-size: 10px; font-weight: 700; line-height: 10px; letter-spacing: -0.5px; white-space: nowrap; color: #3D4E5F;">Water</div>
          <div class="water-badge-subtitle text-dark" style="font-size: 10px; font-weight: 700; line-height: 10px; letter-spacing: -0.5px; white-space: nowrap; color: #3D4E5F;">Resistant</div>
        </div>
      </div>`;
    } else if(herringbone){
      secondaryBadge = `<div class="herringbone-badge-container herringbone-badge-herringbone" style="position: absolute; bottom: 60px; right: 16px; z-index: 15; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px; width: 80px; height: 80px; border-radius: 50%; border: 1px solid #ffffff; background-color: #ACD0D1; color: #3D4E5F;">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="36.275" height="36.278" viewBox="0 0 36.275 36.278" style="width: 30px; height: 30px;">
          <g transform="translate(3 3)">
            <rect width="10.318" height="20.636" transform="translate(7.842 15.141) rotate(-45)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M36.141,68.956H21.55l7.3-7.3Z" transform="translate(-13.708 -39.223)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M68.946,61.66v7.3h-7.3Z" transform="translate(-39.217 -39.223)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M68.946,21.55v14.6l-7.3-7.3v0Z" transform="translate(-39.217 -13.708)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M8.8,1.5,1.5,8.8V1.5Z" transform="translate(-0.954 -0.954)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M43.437,8.8l-7.3,7.3L28.846,8.8l-7.3-7.3H36.142Z" transform="translate(-13.708 -0.954)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M68.946,1.5V8.8l-7.3-7.3Z" transform="translate(-39.217 -0.954)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M16.092,8.8,1.5,23.391V8.8L8.8,1.5Z" transform="translate(-0.954 -0.954)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M16.092,48.905,8.8,56.2H1.5v-7.3l7.3-7.3Z" transform="translate(-0.954 -26.469)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </g>
        </svg>
        <div class="herringbone-badge-content" style="display: flex; flex-direction: column; gap: 0px; text-align: center; align-items: center; justify-content: center;">
          <div class="herringbone-badge-title text-dark" style="font-size: 10px; font-weight: 700; line-height: 10px; letter-spacing: -0.5px; white-space: nowrap; color: #3D4E5F;">Available in</div>
          <div class="herringbone-badge-subtitle text-dark" style="font-size: 10px; font-weight: 700; line-height: 10px; letter-spacing: -0.5px; white-space: nowrap; color: #3D4E5F;">Herringbone</div>
        </div>
      </div>`;
    }
    
    // Product badges from tags (badge:sale, badge:bestseller, etc.)
    let productBadgesHtml = '';
    const badgeTags = tags.filter(tag => String(tag).toLowerCase().includes('badge:'));
    if(badgeTags.length > 0){
      const badges = [];
      badgeTags.forEach(tag => {
        const tagStr = String(tag);
        const badgeTag = tagStr.split(':')[1] || '';
        if(badgeTag === 'sale'){
          badges.push({text: 'Sale', color: '#F85F5F'});
        } else if(badgeTag === 'bestseller'){
          badges.push({text: 'Best Seller', color: '#059669'});
        } else if(badgeTag === 'new'){
          badges.push({text: 'New In', color: '#3B82F6'});
        } else if(badgeTag === 'preorder'){
          badges.push({text: 'Pre Order', color: '#F59E0B'});
        } else if(badgeTag.includes('promo-')){
          const promoValue = badgeTag.split('-')[1] || '';
          badges.push({text: promoValue + '% Off', color: '#8B5CF6'});
        } else if(badgeTag.includes('custom-')){
          const customText = badgeTag.split('-').slice(1).join('-');
          badges.push({text: customText, color: '#000000'});
        }
      });
      
      if(badges.length > 0){
        productBadgesHtml = `<div class="product-card-badges" style="position: absolute; top: 12px; right: 12px; z-index: 15; display: flex; flex-direction: column; gap: 8px; align-items: flex-end; pointer-events: none;">
          <div class="product-badges-PP" style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 0; align-items: flex-end;">
            ${badges.map(badge => `<div class="in-stock-badge" style="background-color: ${badge.color}; padding: 8px 12px; border-radius: 12px; font-size: 12px; font-weight: 700; letter-spacing: -0.5px; color: white; white-space: nowrap; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); pointer-events: auto;">${badge.text}</div>`).join('')}
          </div>
        </div>`;
      }
    }

    const isFlooring = !!p.is_flooring;
    const hasCompare = isFlooring ? (p.pricing && p.pricing.per_m2_compare_at_price && p.pricing.per_m2_compare_at_price > p.pricing.per_m2_price) : (p.variants && p.variants[0] && p.variants[0].compare_at_price > p.variants[0].price);

    let priceHtml = '';
    if(isFlooring){
      if(hasCompare){
        priceHtml = `<span class="current-price">${p.pricing.formatted && p.pricing.formatted.now_per_m2 ? p.pricing.formatted.now_per_m2 : ('Now ' + formatMoneyMinor(p.pricing.per_m2_price, p.pricing.currency) + 'm²')}</span>
        <span class="original-price text-dark">${p.pricing.formatted && p.pricing.formatted.was_per_m2 ? p.pricing.formatted.was_per_m2 : (formatMoneyMinor(p.pricing.per_m2_compare_at_price, p.pricing.currency) + 'm²')}</span>`;
      } else {
        priceHtml = `<span class="current-price">${p.pricing.formatted && p.pricing.formatted.now_per_m2 ? p.pricing.formatted.now_per_m2 : (formatMoneyMinor(p.pricing.per_m2_price, p.pricing.currency) + 'm²')}</span>`;
      }
    } else {
      const v = (p.variants||[])[0] || {};
      if(hasCompare){
        priceHtml = `<span class="current-price">Now ${formatMoneyMinor(v.price, p.pricing && p.pricing.currency)}</span>
        <span class="original-price text-dark">${formatMoneyMinor(v.compare_at_price, p.pricing && p.pricing.currency)}</span>`;
      } else {
        priceHtml = `<span class="current-price">${formatMoneyMinor(v.price, p.pricing && p.pricing.currency)}</span>`;
      }
    }

    const dims = p.dimensions || {};
    const widthSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="22.352" height="9.014" viewBox="0 0 22.352 9.014"><g transform="translate(0 0)"><path d="M22.314,4.7a.5.5,0,0,0,0-.382.486.486,0,0,0-.109-.163L18.2.147a.5.5,0,0,0-.707.707l3.153,3.153H1.706L4.859.854A.5.5,0,0,0,4.152.147l-4,4.006a.486.486,0,0,0-.109.163.5.5,0,0,0,0,.382.477.477,0,0,0,.109.163L4.153,8.867a.5.5,0,0,0,.707,0,.5.5,0,0,0,0-.707L1.706,5.007H20.645L17.492,8.16a.5.5,0,1,0,.707.707L22.2,4.861a.477.477,0,0,0,.109-.163" fill="#3d4e5f"/></g></svg>`;
    const heightSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="22.352" height="9.014" viewBox="0 0 22.352 9.014"><g transform="translate(0 0)"><path d="M22.314,4.7a.5.5,0,0,0,0-.382.486.486,0,0,0-.109-.163L18.2.147a.5.5,0,0,0-.707.707l3.153,3.153H1.706L4.859.854A.5.5,0,0,0,4.152.147l-4,4.006a.486.486,0,0,0-.109.163.5.5,0,0,0,0,.382.477.477,0,0,0,.109.163L4.153,8.867a.5.5,0,0,0,.707,0,.5.5,0,0,0,0-.707L1.706,5.007H20.645L17.492,8.16a.5.5,0,1,0,.707.707L22.2,4.861a.477.477,0,0,0,.109-.163" fill="#3d4e5f"/></g></svg>`;
    const thicknessSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="11.544" height="22.353" viewBox="0 0 11.544 22.353"><g transform="translate(0 0)"><path d="M5.418,8.71a.518.518,0,0,0,.163.109.5.5,0,0,0,.545-.109L10.132,4.7A.5.5,0,1,0,9.425,4L6.272,7.15V.5a.5.5,0,0,0-1,0V7.15L2.119,4a.5.5,0,0,0-.707.707Z" fill="#3d4e5f"/><path d="M6.126,13.641a.518.518,0,0,0-.163-.109.5.5,0,0,0-.545.109L1.412,17.647a.5.5,0,1,0,.707.707L5.272,15.2v6.651a.5.5,0,0,0,1,0V15.2l3.153,3.153a.5.5,0,1,0,.707-.707Z" fill="#3d4e5f"/><path d="M11.044,10.676H.5a.5.5,0,0,0,0,1H11.044a.5.5,0,0,0,0-1" fill="#3d4e5f"/></g></svg>`;

    // Check if product is carpet (tag contains "carpet") and has pile height metafield
    const isCarpet = (p.tags || []).some(t => t.toLowerCase().includes('carpet'));
    const pileHeightRaw = p.metafields && p.metafields.custom && p.metafields.custom.pile_height;
    let thicknessContent = '';
    if (isCarpet && pileHeightRaw) {
      const pileHeightNum = String(pileHeightRaw).replace(/mm/i, '').trim();
      const iconUrl = window.PILE_HEIGHT_ICONS && window.PILE_HEIGHT_ICONS[pileHeightNum];
      if (iconUrl) {
        thicknessContent = `<img src="${iconUrl}" alt="${pileHeightNum}mm Pile Height" class="pile-height-icon" style="width:22px;height:auto;"><span class="dimension-text">${pileHeightNum}mm</span>`;
      } else {
        thicknessContent = `${thicknessSvg}<span class="dimension-text">${pileHeightNum}mm</span>`;
      }
    } else if (dims.thickness_mm) {
      thicknessContent = `${thicknessSvg}<span class="dimension-text">${dims.thickness_mm}mm</span>`;
    }

    const dimensionsHtml = !p.is_accessory ? (`<p class="product-dimensions">`
      + (dims.width_mm ? `${widthSvg}<span class="dimension-text">${dims.width_mm}mm</span>`: '')
      + (dims.length_mm ? `<span class="dimension-length-svg">${heightSvg}</span><span class="dimension-text">${dims.length_mm}mm</span>`: '')
      + thicknessContent
      + `</p>`) : '';

    // Check for sample availability per /listings API docs
    const sampleData = p.sample || {};
    const hasSample = sampleData.has_sample && sampleData.sample_is_active;
    const sampleProductHandle = hasSample ? (sampleData.sample_product_handle || '') : '';
    const sampleImage = (sampleData.sample_image) ? sampleData.sample_image :
                        (firstImg && firstImg.src) ? firstImg.src : '';

    const sampleBtn = (hasSample && sampleProductHandle) ? `<button type="button" class="sample-button" onclick="(function(e){e.preventDefault();e.stopPropagation(); window.__lastSampleParentHandle='${(p.handle||'').replace(/'/g,"\\'")}'; if (typeof addSampleToCart === 'function'){ addSampleToCart('${sampleProductHandle.replace(/'/g,"\\'")}', '${(p.title||'').replace(/'/g,"\\'")}', '${sampleImage.replace(/'/g,"\\'")}'); }})(event); return false;">+ Free Sample</button>` : '';

    // Wishlist button HTML - matches SSR product card
    // Extract numeric Shopify ID from GID format (gid://shopify/Product/123456) -> 123456
    // IMPORTANT: API expects Shopify product ID, NOT internal database ID
    function extractShopifyId(gidOrId) {
      if (!gidOrId) return null;
      if (typeof gidOrId === 'number') return gidOrId;
      if (typeof gidOrId === 'string') {
        // Check if it's a GID format: gid://shopify/Product/123456
        const match = gidOrId.match(/\/Product\/(\d+)$/);
        if (match) return parseInt(match[1], 10);
        // If it's already a numeric string, parse it
        const num = parseInt(gidOrId, 10);
        if (!isNaN(num)) return num;
      }
      return null;
    }
    
    // Extract Shopify ID - DO NOT fall back to internal database ID (p.id)
    // The API requires Shopify product ID, not internal database ID
    const productIdForAPI = extractShopifyId(p.shopify_id);
    if (!productIdForAPI) {
      console.error('Product missing valid shopify_id - cannot add to wishlist/compare:', {
        internalId: p.id,
        title: p.title,
        shopify_id: p.shopify_id
      });
    }
    
    const firstVariant = p.variants && p.variants[0];
    const variantIdForAPI = firstVariant ? extractShopifyId(firstVariant.shopify_id) : null;
    
    // Only render wishlist/compare buttons if we have a valid Shopify product ID
    let wishlistBtn = '';
    let comparePillBtn = '';
    
    if (productIdForAPI) {
      // Add 'wishlist-added' class if product is in wishlist
      const isInWishlist = p.is_in_wishlist || false;
      wishlistBtn = `
      <button 
        class="wishlist-button wishlist-button-custom product_${productIdForAPI}${isInWishlist ? ' wishlist-added' : ''}"
        data-product-id="${productIdForAPI}"
        data-variant-id="${variantIdForAPI || ''}"
        data-product-title="${(p.title || '').replace(/"/g, '&quot;')}"
        data-product-image="${(firstImg && firstImg.src) || ''}"
        data-product-handle="${p.handle || ''}"
        data-custom-wishlist="true"
        aria-label="Add to Wishlist"
        type="button"
        onclick="event.stopPropagation(); event.preventDefault(); window.addToWishlist(event, ${productIdForAPI}, ${variantIdForAPI || 0}, '${(p.title || '').replace(/'/g, "\\'")}', '${((firstImg && firstImg.src) || '').replace(/'/g, "\\'")}', '${(p.handle || '').replace(/'/g, "\\'")}'); return false;"
        style="display: block !important; visibility: visible !important; opacity: 1 !important;">
        <div class="wishlist-icon-default">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.027" height="28.027" viewBox="0 0 28.027 28.027">
            <g transform="translate(1 1)">
              <g transform="translate(-1 -1)">
                <path d="M22.562,18.768l-6.574,6.575-6.58-6.575a4.651,4.651,0,0,1,6.58-6.575,4.649,4.649,0,0,1,6.574,6.575Z" transform="translate(-1.971 -3.071)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <path d="M12.2,0A12.2,12.2,0,1,1,0,12.2,12.2,12.2,0,0,1,12.2,0Z" transform="translate(1.814 1.814)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-width="1.5"/>
              </g>
            </g>
          </svg>
        </div>
        <div class="wishlist-icon-saved">
          <svg xmlns="http://www.w3.org/2000/svg" width="28.027" height="28.027" viewBox="0 0 28.027 28.027">
            <g transform="translate(1 1)">
              <g transform="translate(-1 -1)">
                <path d="M22.562,18.768l-6.574,6.575-6.58-6.575a4.651,4.651,0,0,1,6.58-6.575,4.649,4.649,0,0,1,6.574,6.575Z" transform="translate(-1.971 -3.071)" fill="#ACD0D1" stroke="#ACD0D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <path d="M12.2,0A12.2,12.2,0,1,1,0,12.2,12.2,12.2,0,0,1,12.2,0Z" transform="translate(1.814 1.814)" fill="none" stroke="#3d4e5f" stroke-linecap="round" stroke-width="1.5"/>
              </g>
            </g>
          </svg>
        </div>
      </button>
    `;

      // Compare pill button HTML - matches SSR product card (top left of image)
      // Use Shopify ID (extracted from shopify_id), never use internal database ID
      comparePillBtn = `
      <button 
        type="button"
        class="compare-pill-button" 
        data-compare-button
        data-product-id="${productIdForAPI}"
        data-variant-id="${variantIdForAPI || ''}"
        onclick="event.preventDefault(); event.stopPropagation(); if (typeof window.handleCompareClick === 'function') { window.handleCompareClick(${productIdForAPI}, ${variantIdForAPI || 0}); } return false;"
        aria-label="Add to compare"
      >
        <span class="compare-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4H8V8H4V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <path d="M12 4H16V8H12V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <path d="M4 12H8V16H4V12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <path d="M12 12H16V16H12V12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
            <path d="M6 6L14 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M6 14L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M10 6L10 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <span class="compare-plus">+</span>
        <span class="compare-text">Add To Compare</span>
      </button>
    `;
    }

    // Arrow SVG for image carousel - Exact match from card-arrow-svg.liquid
    const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10.947" height="20" viewBox="0 0 10.947 20"><g id="Group_124" data-name="Group 124"><path id="Path_156" data-name="Path 156" d="M10,20a.944.944,0,0,1-.67-.277L.278,10.671a.946.946,0,0,1,0-1.339L9.33.278a.947.947,0,1,1,1.339,1.339L2.286,10l8.384,8.383A.947.947,0,0,1,10,20" transform="translate(0 0)" fill="#fff"/></g></svg>`;
    
    return `
<product-card class="product-card" data-product-id="${p.id}" data-product-variants-size="${(p.variants||[]).length}">
  <a href="${productUrl}" class="product-card-link" ref="productCardLink">
    <div class="product-image">
      <div class="product-image-container" data-product-id="${p.id}">
        ${imgStack}
        ${hasMultiple ? `<div class="product-image-overlay">
          <div class="product-arrow-left" onclick="event.preventDefault(); event.stopPropagation(); scrollProductImages('${p.id}', -1, event)">${arrowSvg}</div>
          <div class="product-arrow-right" onclick="event.preventDefault(); event.stopPropagation(); scrollProductImages('${p.id}', 1, event)">${arrowSvg}</div>
        </div>` : ''}
        ${secondaryBadge}
        ${productBadgesHtml}
        ${comparePillBtn}
      </div>
      ${dimensionsHtml}
    </div>
    <div class="product-details">
      <div class="product-card__compare-slot" data-compare-slot></div>
      <div class="product-card-actions">
        ${wishlistBtn}
      </div>
      <div class="product-rating">
        ${renderRating(p.ratings)}
      </div>
      <h4 class="product-name text-dark">${displayTitle}</h4>
      <div class="product-price-container">
        <div class="product-price">${priceHtml}</div>
        <div class="product-actions">${sampleBtn}</div>
      </div>
    </div>
  </a>
</product-card>`
  }

  function renderPromoCard(position){
    // Get promo settings from window (injected by Liquid)
    const promoSettings = window.PROMO_CARD_SETTINGS || {};
    
    // Fallback defaults
    const promos = {
      5: {
        desktop_img: promoSettings.promo1_desktop || '',
        mobile_img: promoSettings.promo1_mobile || '',
        link: promoSettings.promo1_link || '/pages/flooring-finder',
        button_text: promoSettings.promo1_button || 'Get Free Delivery',
        alt: 'Free Delivery Promo'
      },
      19: {
        desktop_img: promoSettings.promo2_desktop || '',
        mobile_img: promoSettings.promo2_mobile || '',
        link: promoSettings.promo2_link || '/pages/flooring-finder',
        button_text: promoSettings.promo2_button || 'Launch Flooring Finder',
        alt: 'Flooring Finder Promo'
      }
    };
    const promo = promos[position];
    if(!promo) return '';
    
    // Only render if we have images
    if(!promo.desktop_img && !promo.mobile_img) return '';
    
    return `
      <div class="category-grid-promo-card desktop-promo-card" onclick="window.location.href='${promo.link}'">
        ${promo.desktop_img ? `<img src="${promo.desktop_img}" alt="${promo.alt}" width="398" height="200">` : ''}
        <div class="promo-card-overlay">
          <button class="promo-card-button">${promo.button_text}</button>
        </div>
      </div>
      <div class="category-grid-promo-card mobile-promo-card" onclick="window.location.href='${promo.link}'">
        ${promo.mobile_img ? `<img src="${promo.mobile_img}" alt="${promo.alt}" width="398" height="200">` : ''}
        <div class="promo-card-overlay">
          <button class="promo-card-button">${promo.button_text}</button>
        </div>
      </div>
    `;
  }

  function renderGrid(response){
    csrProductsRendered = true;
    const ssrGrid = $('[data-ssr-grid]');
    const clientGrid = $('[data-client-grid]');
    if(!clientGrid) return;
    
    const isSearch = isSearchPage();
    const products = (response.products || []).filter(p => p && p.id);
    
    // Build HTML with promo cards injected at specific positions
    const cards = [];
    products.forEach((product, idx) => {
      const cardHtml = renderProductCard(product);
      if(cardHtml) cards.push(cardHtml); // Only add if we got valid HTML
      const cardCount = idx + 1;
      // Inject promo cards only if we have enough products (skip for search pages)
      if(!isSearch){
        if(cardCount === 4 && products.length >= 5){
          const promoHtml = renderPromoCard(5);
          if(promoHtml) cards.push(promoHtml);
        }
        if(cardCount === 18 && products.length >= 19){
          const promoHtml = renderPromoCard(19);
          if(promoHtml) cards.push(promoHtml);
        }
      }
    });
    
    let html = '';
    if(isSearch){
      // For search pages, wrap in the same structure as product-grid.liquid
      html = `<ul class="product-grid" role="list">${cards.join('')}</ul>`;
    } else {
      // For collection pages, just the cards
      html = cards.join('');
    }
    
    // Set client grid content
    clientGrid.innerHTML = html + '<div class="pagination-wrapper"><div class="products-pagination desktop-pagination"></div><div class="products-pagination mobile-pagination"></div></div>';

    // Update counts
    const countText = response.ui_text && response.ui_text.count_label ? response.ui_text.count_label : (response.pagination ? `${response.pagination.total} Products` : '');
    qsAll('.product-count').forEach(el=> el.textContent = countText);

    // Dispatch event for category-filters-api.js (includes filter/sort data to avoid redundant API call)
    window.dispatchEvent(new CustomEvent('productsLoaded', {
      detail: {
        pagination: response.pagination,
        total: response.pagination ? response.pagination.total : 0,
        available_filters: response.available_filters || null,
        available_sorts: response.available_sorts || null
      }
    }));

    // Render pagination if containers exist
    renderPagination(response);
    
    // Ensure SSR is hidden and CSR is visible (already handled by setLoading)
    if(ssrGrid){
      ssrGrid.style.display = 'none';
    }
    if(clientGrid){
      if(isSearch){
        // For search pages, show as block to match product-grid structure
        clientGrid.style.display = 'block';
      } else {
        // For collection pages, show as grid
        clientGrid.style.display = 'grid';
      }
      clientGrid.style.opacity = '1';
    }
  }

  function renderPagination(response){
    if(!response || !response.pagination) return;
    const pag = response.pagination;
    const totalPages = Number(pag.total_pages || 1);
    const current = Number(pag.page || 1);
    const state = stateFromUrl();

    function pageHref(page){
      const next = Object.assign({}, state, { page });
      const q = buildQuery(next, false);
      const url = new URL(window.location.href);
      url.search = q;
      return url.pathname + url.search;
    }

    function buildDesktop(){
      const parts = [];
      // Prev arrow
      if(current > 1){
        parts.push(`<a href="${pageHref(current-1)}" class="pagination-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></a>`);
      } else {
        parts.push(`<span class="pagination-arrow" style="opacity:0.5; pointer-events:none;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></span>`);
      }
      
      // Page numbers with Shopify-style truncation
      // Show: 1 ... [current-1] [current] [current+1] ... [last]
      const showPages = [];
      if(totalPages <= 7){
        // Show all pages if 7 or fewer
        for(let i=1; i<=totalPages; i++) showPages.push(i);
      } else {
        // Always show first page
        showPages.push(1);
        
        // Show pages around current
        const rangeStart = Math.max(2, current - 1);
        const rangeEnd = Math.min(totalPages - 1, current + 1);
        
        // Add ellipsis after 1 if needed
        if(rangeStart > 2) showPages.push('...');
        
        // Add range around current
        for(let i=rangeStart; i<=rangeEnd; i++){
          if(i > 1 && i < totalPages) showPages.push(i);
        }
        
        // Add ellipsis before last if needed
        if(rangeEnd < totalPages - 1) showPages.push('...');
        
        // Always show last page
        showPages.push(totalPages);
      }
      
      // Render page numbers
      showPages.forEach(page=>{
        if(page === '...'){
          parts.push(`<span class="pagination-dots">...</span>`);
        } else if(page === current){
          parts.push(`<span class="pagination-number active">${page}</span>`);
        } else {
          parts.push(`<a href="${pageHref(page)}" class="pagination-number">${page}</a>`);
        }
      });
      
      // Next arrow
      if(current < totalPages){
        parts.push(`<a href="${pageHref(current+1)}" class="pagination-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></a>`);
      } else {
        parts.push(`<span class="pagination-arrow" style="opacity:0.5; pointer-events:none;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></span>`);
      }
      return parts.join('');
    }

    function buildMobile(){
      // Mobile: [prev] [current] [...] [last] [next]
      const parts = [];
      // Prev arrow
      if(current > 1){ 
        parts.push(`<a href="${pageHref(current-1)}" class="pagination-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></a>`); 
      } else {
        parts.push(`<span class="pagination-arrow" style="opacity:0.5; pointer-events:none;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg></span>`);
      }
      
      // Current page
      parts.push(`<span class="pagination-number active">${current}</span>`);
      
      // Ellipsis if not near end
      if(current < totalPages-1){ parts.push(`<span class="pagination-dots">...</span>`);} 
      
      // Last page
      if(totalPages>1 && current !== totalPages){ 
        parts.push(`<a href="${pageHref(totalPages)}" class="pagination-number">${totalPages}</a>`);
      } 
      
      // Next arrow
      if(current < totalPages){ 
        parts.push(`<a href="${pageHref(current+1)}" class="pagination-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></a>`); 
      } else {
        parts.push(`<span class="pagination-arrow" style="opacity:0.5; pointer-events:none;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg></span>`);
      }
      return parts.join('');
    }

    // Look for pagination containers in the client grid
    const clientGrid = $('[data-client-grid]');
    if(!clientGrid) return;
    
    const desktop = $('.products-pagination.desktop-pagination', clientGrid);
    if(desktop) desktop.innerHTML = buildDesktop();
    const mobile = $('.products-pagination.mobile-pagination', clientGrid);
    if(mobile) mobile.innerHTML = buildMobile();
  }

  // Generate cache key from state
  function getCacheKey(state) {
    const key = JSON.stringify({
      page: state.page,
      per_page: state.per_page,
      sort: state.sort,
      q: state.q,
      price_min: state.price_min,
      price_max: state.price_max,
      filters: state.filters,
      isSearch: isSearchPage(),
      handle: getCollectionHandle()
    });
    return key;
  }

  // Check cache
  function getCachedResponse(cacheKey) {
    const cached = responseCache.get(cacheKey);
    if (!cached) return null;
    
    const now = Date.now();
    if (now - cached.timestamp > CACHE_DURATION) {
      responseCache.delete(cacheKey);
      return null;
    }
    
    return cached.data;
  }

  // Store in cache
  function setCachedResponse(cacheKey, data) {
    responseCache.set(cacheKey, {
      data: data,
      timestamp: Date.now()
    });
    
    // Limit cache size to prevent memory issues
    if (responseCache.size > 50) {
      const firstKey = responseCache.keys().next().value;
      responseCache.delete(firstKey);
    }
  }

  async function fetchAndRender(state, skipCache = false){
    // Cancel any in-flight request
    if (currentAbortController) {
      currentAbortController.abort();
    }

    // Create new AbortController for this request
    currentAbortController = new AbortController();
    const signal = currentAbortController.signal;

    // Determine which fields to request:
    // - If filters/sort/query/price changed → request listings + filters + sorts (counts may change)
    // - If only page changed → request listings only (filter data is already loaded)
    const filterStateKey = getFilterStateKey(state);
    const filtersChanged = lastFilterStateKey === null || lastFilterStateKey !== filterStateKey;
    const fields = filtersChanged ? 'listings,filters,sorts' : 'listings';
    if (filtersChanged) lastFilterStateKey = filterStateKey;

    // Check cache first (unless explicitly skipping)
    if (!skipCache) {
      const cacheKey = getCacheKey(state);
      const cached = getCachedResponse(cacheKey);
      if (cached) {
        renderGrid(cached);
        updateUrl(state);
        return;
      }
    }

    setLoading(true);
    try{
      // Start SSR fallback timer
      if (ssrFallbackTimer) {
        clearTimeout(ssrFallbackTimer);
        ssrFallbackTimer = null;
      }
      ssrFallbackTimer = setTimeout(() => {
        showSsrFallback();
      }, SSR_FALLBACK_TIMEOUT);

      const isSearch = isSearchPage();
      let url;

      if(isSearch){
        // Use search endpoint for search pages
        const q = buildQuery(state, true);
        const qs = q ? `${q}&fields=${fields}` : `fields=${fields}`;
        url = `${API_BASE}/products/search?${qs}`;
      } else {
        // Use collection endpoint for collection pages
        const handle = getCollectionHandle();
        if(!handle) {
          setLoading(false);
          return;
        }
        const q = buildQuery(state, true);
        const qs = q ? `${q}&fields=${fields}` : `fields=${fields}`;
        url = `${API_BASE}/collections/${encodeURIComponent(handle)}/listings?${qs}`;
      }

      const res = await fetch(url, {
        credentials: 'omit',
        headers: {
          'X-Storefront-Key': '7a2918b913ae5bf9e75103ea994aba1df813abd1b185354f3b69304acfd4a17d'
        },
        signal: signal // Add abort signal
      });

      if(!res.ok) throw new Error(`API ${res.status}`);
      const data = await res.json();

      // Cache the response
      const cacheKey = getCacheKey(state);
      setCachedResponse(cacheKey, data);

      renderGrid(data);
      updateUrl(state);
    }catch(e){
      // Ignore abort errors (they're expected when cancelling requests)
      if (e.name === 'AbortError') {
        return;
      }
      console.error('API error', e);
      showSsrFallback();
    }finally{
      setLoading(false);
      if (ssrFallbackTimer) {
        clearTimeout(ssrFallbackTimer);
        ssrFallbackTimer = null;
      }
      // Clear abort controller if this was the current request
      if (currentAbortController && currentAbortController.signal === signal) {
        currentAbortController = null;
      }
    }
  }

  // Debounced version of fetchAndRender
  function debouncedFetchAndRender(state) {
    // Clear existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    // Set new timer
    debounceTimer = setTimeout(() => {
      fetchAndRender(state);
      debounceTimer = null;
    }, DEBOUNCE_DELAY);
  }

  // Public method to update products (called from category-filters-api.js)
  function updateProducts() {
    const state = stateFromUrl();
    debouncedFetchAndRender(state);
  }

  function onFilterClick(e){
    // Ignore clicks on wishlist buttons
    const wishlistButton = e.target.closest('[data-custom-wishlist="true"]');
    if(wishlistButton) return;
    
    // Ignore clicks on product card links
    const productCardLink = e.target.closest('.product-card-link, product-card a[href^="/products/"]');
    if(productCardLink) return;
    
    const target = e.target.closest('[data-url], a[href]');
    if(!target) return;
    const hasDataUrl = target.hasAttribute('data-url');
    const href = hasDataUrl ? target.getAttribute('data-url') : target.getAttribute('href');
    if(!href) return;
    const isInternal = href.startsWith('/') || href.startsWith('?') || href.startsWith(window.location.origin);
    if(!isInternal) return; // let external links work

    // Parse the clicked URL to get the new state
    let url;
    if(href.startsWith('?')) url = new URL(window.location.origin + window.location.pathname + href);
    else url = new URL(href, window.location.origin);

    // If the link points to a different page (e.g. quick collection links from metafields),
    // let the browser do a full navigation instead of a CSR update.
    if(url.pathname !== window.location.pathname) return;

    // If CSR is not active and the destination URL has no filters/price, let the browser
    // navigate normally so Shopify SSR handles pagination natively (no API call needed).
    if(!csrProductsRendered){
      const destParams = url.searchParams;
      const destHasFilters = Array.from(destParams.keys()).some(k => /^filters\[/.test(k) || k.startsWith('filter.'));
      const destHasPrice = destParams.get('price_min') || destParams.get('price_max') || destParams.get('filter.v.price.gte') || destParams.get('filter.v.price.lte');
      if(!destHasFilters && !destHasPrice) return; // let browser navigate — SSR will handle it
    }

    e.preventDefault();

    // Use pushState instead of replaceState for proper history
    window.history.pushState({}, '', url.toString());
    const next = stateFromUrl();

    // Use debounced fetch for better performance
    debouncedFetchAndRender(next);
  }

  function attach(){
    const filtersSection = $('.category-filters');
    if(filtersSection){ filtersSection.addEventListener('click', onFilterClick, true); }

    // Intercept pagination clicks inside products grid too
    const gridWrapper = $('.category-products-grid');
    if(gridWrapper){ gridWrapper.addEventListener('click', onFilterClick, true); }
  }

  async function initialHydrateIfNeeded(){
    const isSearch = isSearchPage();
    const params = new URL(window.location.href).searchParams;
    const hasFilters = Array.from(params.keys()).some(k=>/^filters\[/.test(k) || k.startsWith('filter.'));
    const hasPrice = params.get('price_min') || params.get('price_max') || params.get('filter.v.price.gte') || params.get('filter.v.price.lte');
    const hasQuery = params.get('q'); // For search pages

    // CSR is only needed when our custom filter/price format is in the URL —
    // Shopify SSR handles sort and pagination natively, so those alone never trigger the API.
    if(isSearch){
      if(hasQuery && (hasFilters || hasPrice)){
        const state = stateFromUrl();
        fetchAndRender(state);
      }
    } else {
      if(hasFilters || hasPrice){
        const state = stateFromUrl();
        fetchAndRender(state);
      }
      // Sort-only or page-only: SSR stays, no API call
    }
  }

  // Handle browser back/forward navigation
  window.addEventListener('popstate', function(event) {
    const params = new URL(window.location.href).searchParams;
    const hasFilters = Array.from(params.keys()).some(k => /^filters\[/.test(k) || k.startsWith('filter.'));
    const hasPrice = params.get('price_min') || params.get('price_max') || params.get('filter.v.price.gte') || params.get('filter.v.price.lte');
    if(hasFilters || hasPrice){
      const state = stateFromUrl();
      debouncedFetchAndRender(state);
    } else {
      // No filters — restore SSR (initial Shopify-rendered products)
      csrProductsRendered = false;
      const ssrGrid = $('[data-ssr-grid]');
      const clientGrid = $('[data-client-grid]');
      if(clientGrid){ clientGrid.style.display = 'none'; clientGrid.innerHTML = ''; }
      if(ssrGrid){ ssrGrid.style.display = 'grid'; }
    }
  });

  // Expose public API for category-filters-api.js
  window.collectionHydration = {
    updateProducts: updateProducts,
    fetchAndRender: fetchAndRender,
    debouncedFetchAndRender: debouncedFetchAndRender
  };

  // Only run after DOM ready
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ attach(); initialHydrateIfNeeded(); });
  } else {
    attach();
    initialHydrateIfNeeded();
  }
})();
